<template>
  <fin-step-by-step-question
    :questionIndex="questionIndex"
    :selectable="value>=0"
    :selection-hint="value>=0 ? properties.values[value].tooltip.text : 'Wähle eine Antwort um mehr darüber zu erfahren.'"
    @next="$emit('next')"
    :value="value"
    :question=properties.question
    :questionTitle=properties.title
    :class="$vuetify.breakpoint.mdAndUp ? 'question' : ''"
  >
    <div>
      <illu :value="value"
            :animations="animations"
            :tooltipTexts="properties.values"
            @input="val => $emit('input', val)"
            v-if="$vuetify.breakpoint.mdAndUp"/>
      <fin-step-by-step-carousel-answers v-else
                                         :animations="animations"
                                         :value="value"
                                         :answers="properties.values"
                                         @input="val => {this.$emit('input', val), this.$emit('next')}"
      />
    </div>
  </fin-step-by-step-question>
</template>
<script>
import FinStepByStepQuestion from '@/components/pages/onboarding/Step2/StepByStep/StepByStepQuestion/index'
import Illu from './Illu'
import FinStepByStepCarouselAnswers from "../Carousel/StepByStepCarouselAnswers"

export default {
  name: 'FinStepByStep4',
  components: { FinStepByStepCarouselAnswers, Illu, FinStepByStepQuestion },
  data () {
    return {
        selection: -1
    }
  },
  props: {
    value: {
      type: Number
    },
    questionIndex: {
      type: Number
    },
    properties: {
      type: Object
    },
      animations: {
          type: Array
      }
  }
}
</script>

<style scoped lang="scss">
  .question {
    background: linear-gradient(to bottom, transparent 68%, #EDF1F4 0%);
  }
</style>
